import React from 'react';
import {Input} from 'antd';
import commonRefHOC from '../../commonRefHOC';

const { TextArea } = Input;
export default commonRefHOC(TextArea);